export enum actionTypesArtwork {
  ListOfArtwork = "artworkList",
  IsArtWorkListLoaded = "isArtWorkListLoaded",
}
